import { useQuery, useQueryClient } from '@tanstack/react-query'
import { createContext, use} from 'react'
import { hono_client } from '../hono-client'
import { getIdToken } from '../firebase/init'
import { AuthContext } from './auth-redirector'

type VisitContextType = {
  user_length: number
  cast_length: number
}
export const VisitContext = createContext<VisitContextType | undefined>(undefined)

type Props = {
  children: React.ReactNode
}
export const VisitContextProvider: React.FC<Props> = ({children}) => {
  const user = use(AuthContext)
  const queryClient = useQueryClient()
  const {data} = useQuery({
    queryKey: ['visit'],
    queryFn: ()=>
      getIdToken().then(token=>
        hono_client.visit
          .$get({
            query: {type: user.role}
          }, {
            headers: {
              'firebase-token': token
            }
          })
      )
        .then(r=> r.json())
        .then(data=> {
          if (data.current_point !== undefined) {
            queryClient.setQueryData(['me'], {...user, point: data.current_point})
          }
          return data
        }),
    refetchInterval: 5 * 60 * 1000
  })
  return <VisitContext value={data}>
    {children}
  </VisitContext>
}